import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import usePageTitle from "@/hooks/usePageTitle";

export default function PrivacyPage() {
  usePageTitle("pageTitles.privacy");
  return (
    <div
      className="min-h-screen bg-slate-950 text-slate-100"
      data-testid="privacy-page"
    >
      <div className="max-w-3xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-amber-400 transition-colors mb-8"
          data-testid="privacy-page-back-link"
        >
          <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-full bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center text-slate-950">
            <ShieldCheck className="h-5 w-5" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-white">
            Privacy Policy
          </h1>
        </div>

        <p className="text-xs uppercase tracking-wider text-amber-400 mb-8">
          Effective Date: September 30, 2026
        </p>

        <div className="space-y-6 text-slate-300 leading-relaxed">
          <p>
            <strong className="text-white">Kritajna Ventures LLP</strong>{" "}
            respects your privacy. This policy explains how we collect and
            safeguard your information.
          </p>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">
              Information We Collect
            </h2>
            <p>
              We collect personal details (name, email, business name) during
              registration. Payment data is securely processed by third-party
              gateways; we do not store full credit card numbers. We also
              collect usage data to improve performance.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">
              How We Use Your Information
            </h2>
            <p>
              To operate the platform, process transactions, provide customer
              support (
              <a
                href="mailto:admin@kritajnaventures.com"
                className="text-amber-400 hover:underline"
              >
                admin@kritajnaventures.com
              </a>
              ), and prevent fraud.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">Data Sharing</h2>
            <p>
              We do not sell your personal information. We only share data with
              trusted service providers or for legal compliance.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">Data Security</h2>
            <p>
              We implement industry-standard security measures, though no
              internet transmission is 100% secure.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-white">Contact Us</h2>
            <p>
              For questions, contact{" "}
              <a
                href="mailto:admin@kritajnaventures.com"
                className="text-amber-400 hover:underline"
              >
                admin@kritajnaventures.com
              </a>
              .
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
